"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferingIntent = void 0;
var OfferingIntent;
(function (OfferingIntent) {
    OfferingIntent["SHOW_DETAILS"] = "showDetails";
    OfferingIntent["BOOK_OFFERING"] = "bookOffering";
})(OfferingIntent = exports.OfferingIntent || (exports.OfferingIntent = {}));
//# sourceMappingURL=constants.js.map